<template>

</template>

<script>
export default {
  name: "County",
  components: {

  },
  data() {
    return {

    }
  },
  methods: {
    createData() {

    },
    toDataV() {
      // let href = `http://192.168.100.9:8080`

      let t = JSON.parse(localStorage.getItem("USER_TOKEN"))
      document.cookie ="token="+t+"; path=/ ; domain=.jinchanhb.com"
      let href = `http://county.jinchanhb.com`
      window.open(href, '_blank');
    }
  },
  mounted() {
    const {toDataV} = this;
    toDataV();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bigdata/county/index.vue